import React from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import HeaderPublic from '../../components/Header/HeaderPublic';
import strings from '../../components/Language';
import { images } from '../../config/image';
import { api } from '../../components/config/api';
import { Helmet } from 'react-helmet';
import './front-professional.scss';

class Front extends React.Component {
  constructor(props) {
    super(props);

    this.defaultMarketPairs = [
      { pair: 'BTCUSDT', displayPair: 'BTC/USDT', price: '0.00', change: '+0.00%', isDown: false },
      { pair: 'ETHUSDT', displayPair: 'ETH/USDT', price: '0.00', change: '+0.00%', isDown: false },
      { pair: 'SOLUSDT', displayPair: 'SOL/USDT', price: '0.00', change: '+0.00%', isDown: false },
      { pair: 'BNBUSDT', displayPair: 'BNB/USDT', price: '0.00', change: '+0.00%', isDown: false },
      { pair: 'XRPUSDT', displayPair: 'XRP/USDT', price: '0.00', change: '+0.00%', isDown: false }
    ];

    this.state = {
      marketPairs: this.defaultMarketPairs
    };
  }

  componentDidMount() {
    this.getLiveMarketData();
    this.marketInterval = setInterval(this.getLiveMarketData, 10000);
  }

  componentWillUnmount() {
    if (this.marketInterval) {
      clearInterval(this.marketInterval);
    }
  }

  getLiveMarketData = () => {
    axios({
      method: 'GET',
      url: api.marketData,
      headers: {
        'Accept-Language': strings.getLanguage(),
      }
    }).then((response) => {
      if (response && response.status === 200 && Array.isArray(response.data)) {
        const marketPairs = this.defaultMarketPairs.map((item) => {
          const liveItem = response.data.find((market) => market.symbol === item.pair);
          const priceChangePercent = Number.parseFloat(liveItem?.priceChangePercent || 0);
          const lastPrice = Number.parseFloat(liveItem?.lastPrice || 0);

          return {
            ...item,
            price: lastPrice ? lastPrice.toFixed(lastPrice >= 100 ? 2 : 5) : '0.00',
            change: `${priceChangePercent >= 0 ? '+' : ''}${priceChangePercent.toFixed(2)}%`,
            isDown: priceChangePercent < 0
          };
        });

        this.setState({ marketPairs });
      }
    }).catch(() => {
    });
  };

  render() {
    const { marketPairs } = this.state;
    const canonicalUrl = `${window.location.origin}/`;
    const seoTitle = 'CTS Bot | Smart Crypto Trading Platform';
    const seoDescription = 'Trade smarter with CTS Bot. Automated crypto strategies, risk-managed execution, and a professional platform for modern traders.';
    const seoImage = `${window.location.origin}/apple-touch-icon.png`;
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'CTS Bot',
      url: canonicalUrl,
      description: seoDescription,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${window.location.origin}/?q={search_term_string}`,
        'query-input': 'required name=search_term_string'
      }
    };

    const botPreviews = [
      { label: 'AI BOT', profit: '+16.42%', pair: 'BTC/USDT', period: '7D Performance' },
      { label: 'CTS BOT', profit: '+9.85%', pair: 'ETH/USDT', period: '30D Performance' },
      { label: 'DCA BOT', profit: '+11.04%', pair: 'SOL/USDT', period: 'Risk Balanced' }
    ];

    const whyCards = [
      { title: strings.emotionless_trading, desc: strings.emotionless_trading_desc },
      { title: strings.higher_trading_speed, desc: strings.higher_trading_speed_desc },
      { title: strings.risk_diversification, desc: strings.risk_diversification_desc }
    ];

    const strategyCards = [
      { tag: 'Automation', title: strings.DCA, desc: strings.robot_strategy_dca_desc },
      { tag: 'Trend Logic', title: strings.robot_strategy_bollinger_middle, desc: strings.robot_strategy_bollinger_middle_desc },
      { tag: 'Re-entry', title: strings.robot_strategy_bollinger_bottom, desc: strings.robot_strategy_bollinger_bottom_desc }
    ];

    const advantageCards = [
      { image: images['icon-advantage1'], text: strings.our_advantages_1, alt: 'adv1' },
      { image: images['icon-advantage2'], text: strings.our_advantages_2, alt: 'adv2' },
      { image: images['icon-advantage3'], text: strings.our_advantages_3, alt: 'adv3' }
    ];

    return (
      <div className="landing-body profront-page">
        <Helmet>
          <title>{seoTitle}</title>
          <meta name="description" content={seoDescription} />
          <meta name="keywords" content="crypto trading bot, automated trading, quantitative trading, CTS Bot, bitcoin bot, algorithmic trading" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={canonicalUrl} />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={seoTitle} />
          <meta property="og:description" content={seoDescription} />
          <meta property="og:url" content={canonicalUrl} />
          <meta property="og:image" content={seoImage} />
          <meta property="og:site_name" content="CTS Bot" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={seoTitle} />
          <meta name="twitter:description" content={seoDescription} />
          <meta name="twitter:image" content={seoImage} />

          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Helmet>

        <HeaderPublic />

        <main className="profront-main">
          <section className="profront-hero">
            <img className="profront-hero-bg" src={images['landing-bg1']} alt="hero" />
            <div className="profront-hero-overlay" />

            <div className="profront-hero-content">
              <p className="profront-kicker">CTS BOT</p>
              <h1>{strings.online_trading_never_been_this_easy}</h1>
              <p className="profront-copy">{strings.online_trading_never_been_this_easy_desc}</p>

              <div className="profront-actions">
                <NavLink to="/register" className="profront-btn profront-btn-primary">
                  {strings.GET_STARTED_NOW}
                </NavLink>
                <NavLink to="/login" className="profront-btn profront-btn-secondary">
                  {strings.member_login}
                </NavLink>
              </div>

              <div className="profront-market-strip">
                <div className="profront-market-track">
                  {[...marketPairs, ...marketPairs].map((item, i) => (
                    <span key={`${item.pair}-${i}`} className="profront-pair-chip">
                      {item.displayPair} ${item.price} <b className={item.isDown ? 'profront-down' : ''}>{item.change}</b>
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="profront-bot-preview">
              {botPreviews.map((item) => (
                <article key={item.label} className="profront-bot-card">
                  <div className="profront-bot-head">
                    <span><i className="profront-live-dot" />{item.label}</span>
                    <strong className="profront-up">{item.profit}</strong>
                  </div>
                  <p>Pair: {item.pair}</p>
                  <small>{item.period}</small>
                </article>
              ))}
            </div>
          </section>

          <section className="profront-section">
            <div className="profront-section-head">
              <h2>{strings.buy_and_sell_cryptocurrency}</h2>
              <p>{strings.buy_and_sell_cryptocurrency_desc}</p>
            </div>
          </section>

          <section className="profront-section">
            <h2 className="profront-title">Why CTS Bot</h2>
            <div className="profront-grid profront-grid-3">
              {whyCards.map((item) => (
                <article key={item.title} className="profront-card">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="profront-section">
            <h2 className="profront-title">{strings.robot_strategy}</h2>
            <div className="profront-grid profront-grid-3">
              {strategyCards.map((item) => (
                <article key={item.title} className="profront-card profront-card-strategy">
                  <label className="profront-strategy-tag">{item.tag}</label>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="profront-section">
            <h2 className="profront-title">{strings.our_advantages}</h2>
            <div className="profront-grid profront-grid-3 profront-adv-grid">
              {advantageCards.map((item) => (
                <article key={item.alt} className="profront-adv-card">
                  <img src={item.image} alt={item.alt} />
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="profront-section">
            <div className="profront-cta-panel">
              <div>
                <h2>{strings.easy_way_to_trade_your_cryptocurrency}</h2>
                <p>{strings.easy_way_to_trade_your_cryptocurrency_desc}</p>
              </div>
              <div className="profront-actions">
                <NavLink to="/register" className="profront-btn profront-btn-primary">
                  {strings.register}
                </NavLink>
              </div>
            </div>
          </section>
        </main>

        <footer className="profront-footer">
          <img src={images['logo']} alt="logo" />
          <p>{strings.copyright_string}</p>
        </footer>
      </div>
    );
  }
}

export default Front;
